var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_3102",
    "data-name": "Gruppe 3102",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 30,
    viewBox: "0 0 43 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_3101",
    "data-name": "Gruppe 3101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_2467",
    "data-name": "Gruppe 2467",
    transform: "translate(4.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "status_grey"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1028",
    "data-name": "Pfad 1028",
    d: "M16.426,19.291c-6.929,0-8.6-2.605-8.733-2.911l-.131-.189V9.436A1.1,1.1,0,0,1,8.056,8.5,1.121,1.121,0,0,1,9.1,8.41l7.336,3.1L29.606,6.416,17,1.765a1.244,1.244,0,0,0-.844,0L1.135,7.209A.847.847,0,0,1,.56,5.615L15.582.179a2.911,2.911,0,0,1,2.009,0L31.171,5.2a1.3,1.3,0,0,1,.852,1.208,1.288,1.288,0,0,1-.837,1.23L16.411,13.344,9.257,10.31v5.378a4.214,4.214,0,0,0,1.245.859,13.564,13.564,0,0,0,5.924,1.048c5.022,0,7.191-1.572,7.795-2.118V13.5a.852.852,0,0,1,1.7,0V16.11l-.175.226c-.095.116-2.343,2.955-9.316,2.955Z",
    fill: "#238cb9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_1029",
    "data-name": "Pfad 1029",
    d: "M.844,11.122A.844.844,0,0,1,0,10.27V7.3A3.872,3.872,0,0,1,2.548,3.662L12.591.059a.86.86,0,1,1,.626,1.6L3.173,5.263A2.183,2.183,0,0,0,1.718,7.3V10.27a.852.852,0,0,1-.873.852Z",
    transform: "translate(4.978 2.616)",
    fill: "#238cb9",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourse);
export default __webpack_public_path__ + "static/media/course.b2af2156bf0c46db3cb393adb22f6a97.svg";
export { ForwardRef as ReactComponent };